<template>
    <form>
        <b-modal :active.sync="isComponentModalActive"
                 full-screen
                 has-modal-card  >

            <div class="modal-card ">

                <section class="modal-card-body"  >
                    <!-- Content ... -->
                    <b-loading  :active.sync="isFullScreenSearching" ></b-loading>



                    <b-tabs v-model="mainTab">

                        <b-tab-item label="All My Blogs">
                            <b-button type="is-success" outlined @click="newBlog">New Blog</b-button>
                        </b-tab-item>



                        <b-tab-item label="New/Edit Blog"  :disabled="newEditDisable">

                            <b-tabs >

<!--                                Title : <b><div v-html="title"></div></b>-->
<!--                                <hr>-->
<!--                                Content:-->
<!--                                <div v-html="content"></div>-->
<!--                                -->
<!--                                    <b-field label="Title">-->
<!--                                      <b-input v-model="title"></b-input>-->
<!--                                    </b-field>-->

<!--                                    <b-field label="Content">-->
<!--                                        <vue-editor v-model="content" :editor-toolbar="customToolbar" />-->
<!--                                    </b-field>-->

<!--                                    <b-select placeholder="Status" v-model="statusBlog">-->
<!--                                      <option  value="0"> Draft  </option>-->
<!--                                      <option  value="1"> Publish  </option>-->
<!--                                    </b-select>-->
<!--                                   <br>-->
<!--                                    <b-button type="is-success"-->
<!--                                          icon-left="content-save"  @click="saveBlog"   >-->
<!--                                       Save-->
<!--                                    </b-button>-->



<!--                                <b-field label="Title">&ndash;&gt;-->
<!--                                    &lt;!&ndash;                                        <b-input v-model="title"></b-input>&ndash;&gt;-->
<!--                                    &lt;!&ndash;                                    </b-field>&ndash;&gt;-->

<!--                                    &lt;!&ndash;                                    <b-field label="Content">&ndash;&gt;-->
<!--                                    &lt;!&ndash;                                        <vue-editor v-model="content" />&ndash;&gt;-->
<!--                                    &lt;!&ndash;                                    </b-field>&ndash;&gt;-->

<!--                                    &lt;!&ndash;                                    <b-select placeholder="Status" v-model="statusBlog">&ndash;&gt;-->
<!--                                    &lt;!&ndash;                                        <option  value="0"> Draft  </option>&ndash;&gt;-->
<!--                                    &lt;!&ndash;                                        <option  value="1"> Publish  </option>&ndash;&gt;-->
<!--                                    &lt;!&ndash;                                    </b-select>&ndash;&gt;-->
<!--                                    &lt;!&ndash;                                    <br>&ndash;&gt;-->
<!--                                    &lt;!&ndash;                                    <b-button type="is-success"&ndash;&gt;-->
<!--                                    &lt;!&ndash;                                              icon-left="content-save"  @click="saveBlog"   >&ndash;&gt;-->
<!--                                    &lt;!&ndash;                                        Save&ndash;&gt;-->
<!--                                    &lt;!&ndash;                                    </b-button>&ndash;&gt;-->

<!--                                <div class="columns">-->
<!--                                    <div class="column">-->
<!--                                        <b-button  icon-left="history" size="is-small" type="is-info">History</b-button>-->
<!--                                        <b-button  icon-left="history" size="is-small" type="is-info">History</b-button>-->
<!--                                        <b-button  icon-left="history" size="is-small" type="is-info">History</b-button>-->
<!--                                    </div>-->

<!--                                </div>-->





                                <b-navbar>

                                    <template slot="start">
                                        <b-navbar-item href="#">
                                             <b-button  icon-left="history" size="is-small" type="is-info"  @click="addText('History')">History</b-button>
                                        </b-navbar-item>
                                        <b-navbar-item href="#">
                                            <b-button  icon-left="history" size="is-small" type="is-info" @click="addText('Histopathological findings')">Histopathological findings</b-button>
                                        </b-navbar-item>
                                        <b-navbar-item href="#">
                                            <b-button  icon-left="history" size="is-small" type="is-info" @click="addText('Comments')">Comments</b-button>
                                        </b-navbar-item>
                                    </template>


                                </b-navbar>

                                <b-tab-item label="Input">
                                    <b-field label="Title">
                                        <b-input v-model="title"></b-input>
                                    </b-field>


                                    <b-field label="Content">
                                        <vue-editor v-model="content" :editor-toolbar="customToolbar"  useCustomImageHandler id="editor"  @imageAdded="handleImageAdded" ref="editor" />

                                    </b-field>

                                    <b-select placeholder="Status" v-model="statusBlog">
                                        <option  value="0"> Draft  </option>
                                        <option  value="1"> Publish  </option>
                                    </b-select>
                                    <br>
                                    <b-button type="is-success"
                                              icon-left="content-save"  @click="confirmToSaveBlog"   >
                                        Save
                                    </b-button>


                                    <b-field label="content">
                                        <b-input maxlength="200" type="textarea" v-model="getHTMLStringify"></b-input>
                                    </b-field>
{{getHTMLStringify.length}}<br>
<!--                                    {{ getPerCent }}-->
<!--                                    <b-progress  :type="getPerCent>100 ?'is-danger' : 'is-info' "  :value="getPerCent" show-value></b-progress>-->
<!--                                    <b-field label="getTextFromHTML">-->
<!--                                        <b-input maxlength="200" type="textarea" v-model="getTextFromHTML"></b-input>-->
<!--                                    </b-field>-->
<!-- {{getTextFromHTML.length}}-->


                                </b-tab-item>

                                <b-tab-item label="Preview">
                                    Title : <b><div v-html="title"></div></b>
                                    <hr>
                                    Content:
                                    <div v-html="getHTMLParse"></div>

                                </b-tab-item>
                            </b-tabs>

                        </b-tab-item>



                    </b-tabs>








                </section>
                <footer class="modal-card-foot">

                    <b-button type="is-danger"
                              icon-left="close"  @click="closeModal"   >
                        Close
                    </b-button>








                </footer>
            </div>

        </b-modal>
    </form>
</template>

<script>
    /* eslint-disable no-console */
    import { VueEditor } from "vue2-editor"
    import  htmlToText  from "html-to-text"
    import axios from "axios"
    import {   getBaseURLforBackEnd  , getConfigAxios  } from '@/utils.js'
    import { mapState } from "vuex";



    export default {
        name: "Blog" ,
        components: {  VueEditor },
        methods:{
            addText(text){
                this.$refs.editor.quill.focus()
                const space = '    '


                if(this.$refs.editor.quill.getSelection().index !== null) {
                    this.$refs.editor.quill.insertText(this.$refs.editor.quill.getSelection().index, text , 'bold', true)
                    this.$refs.editor.quill.setSelection(  this.$refs.editor.quill.getSelection().index + text.length )
                    this.$refs.editor.quill.insertText(this.$refs.editor.quill.getSelection().index, space , 'bold', true)
                    this.$refs.editor.quill.setSelection(  this.$refs.editor.quill.getSelection().index + space.length )
                    this.$refs.editor.quill.removeFormat(this.$refs.editor.quill.getSelection().index-space.length, space.length);
                    // this.$refs.editor.quill.insertText(this.$refs.editor.quill.getSelection().index, ' test ' , )
                    // this.$refs.editor.quill.formatText(this.$refs.editor.quill.getSelection().index, 0, {                   // unbolds 'hello' and set its color to blue
                    //     'bold': false,
                    // })
                }
            },
            closeModal(){
                this.isComponentModalActive = false
            },
            newBlog(){
                 this.newEditDisable = false
                 this.mainTab = 1
            },
            saveBlog(){
                console.log('real save')
            },
            confirmToSaveBlog(){

                this.$buefy.dialog.confirm({
                    title: 'continue to save?',
                    message: `Confirm to Save  `,
                    cancelText: 'Cancel',
                    confirmText: 'Save',
                    type: 'is-success',
                    onConfirm: () => this.saveBlog()
                })


            },
            handleImageAdded(file,Editor, cursorLocation) {
                // console.log("hi")
                // const CLIENT_ID = '993793b1d8d3e2e'

                var formData = new FormData();
                formData.append('image', file)

                const allowedTypes = ["image/jpeg","image/png","image/gif","image/jpg"]
                const MAX_SIZE = 20000000
                const tooLarge = file.size > MAX_SIZE

                if(allowedTypes.includes(file.type) && !tooLarge){
                    this.file = file
                    this.message = ""
                    this.error = false
                    // console.log('ok')

                    const formData = new FormData()
                    formData.append('file',this.file)
                    formData.append('dat','{ "mode": 1}')
                    try{
                         axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                         axios.post(`${getBaseURLforBackEnd()}/api/upload_avartar`,formData,getConfigAxios())
                            .then((res)=>{
                                Editor.insertEmbed(cursorLocation, 'image', res.data.temp_url);
                                // console.log(res)
                                // vm.urlTempUploaded = res.data.temp_url
                                // vm.fileNameUploaded = res.data.file_name
                            })

                        // this.file = ""
                        this.error = false
                    }catch (e) {
                        console.log(' error : '+e)
                        this.message = e.response.data.error
                        this.error = true
                    }


                }else{
                    this.message = tooLarge ? `Max size ${MAX_SIZE/1000} kb` : "Only images are allow (from Client)"
                    this.error = true
                }




            }
        },
        validations:{

        },
        data(){
            return{
                isComponentModalActive : false ,
                isFullScreenSearching : false,
                newEditDisable : true,
                mainTab : 0 ,

                title : '',
                content : '',
                statusBlog : 0 ,
                // customToolbar : []
                customToolbar: [
                    ["bold", "italic", "underline"],
                    [{ list: "ordered" }, { list: "bullet" }],
                    ["image", "code-block"],
                    [{ 'color': [] }, { 'background': [] }],
                    ['link'],
                ] ,



                file:"",
                message: "",
                error : false,

            }
        },
        computed:{
            ...mapState({
                access_token: state => state.master_data.access_token,
            }),

            getTypeByPerCent: function () {
                return `is-info`
            },
            getPerCent: function () {
                return      ((this.getHTMLStringify.length  / 1000 )* 100).toFixed(2)
            },

           getTextFromHTML:function () {
               return  htmlToText.fromString(this.content, {
                   wordwrap: 130,
                   ignoreImage: true ,
                   ignoreHref: true,
                   trimEmptyLines : false
               });
           },
          getHTMLStringify: function () {
              return    JSON.stringify(this.content)
          },
          getHTMLParse: function () {
              return  JSON.parse(JSON.stringify(this.content))
          }
        },
        watch:{


        }
    }
</script>

<style scoped>

</style>